import { authTokenName } from '../config';
import Cookie from 'js-cookie';

export const authTokenInCookie = (): string => {
  if (process.browser) {
    return Cookie.get(authTokenName);
  }
};
